import apiClient from '$utils/apiClient';
import { clientInfoHeader } from '../../utils/clientInfo';

const fetchInstitution = async () => {
  const { data } = await apiClient.post('/conf/read', {
    modules: ['parse', 'general', 'features', 'launchDarkly'],
  });
  return data;
};

const fetchCurrentUser = async () => {
  try {
    const {
      data: { user },
    } = await apiClient.get('/users/getBySessionToken', {
      withCredentials: true,
    });
    return user;
  } catch (error) {
    return null;
  }
};

const fetchUserInfoOnSpaces = async ({ user }) => {
  const {
    data: {
      user: { spaces },
    },
  } = await apiClient.get(`/users/${user.id}`, {
    withCredentials: true,
  });
  return spaces;
};

const fetchSpaceInfo = async ({ spaceId }) => {
  const {
    data: { space },
  } = await apiClient.get(`/spaces/${spaceId}`, {
    withCredentials: true,
  });
  return space;
};

const fetchAccessToken = async ({ spaceId }) => {
  const authorizeUrl = `/users/authorize?aud=handin&scope=space_${spaceId}`;
  const {
    data: { access_token: accessToken },
  } = await apiClient.get(authorizeUrl, {
    withCredentials: true,
  });

  return accessToken;
};

const regenerateSessionToken = async () => {
  const sessionToken = await apiClient.post(
    '/users/regenerateSessionToken',
    {},
    { headers: { ...clientInfoHeader }, withCredentials: true }
  );
  return sessionToken;
};

export {
  fetchInstitution,
  fetchCurrentUser,
  fetchUserInfoOnSpaces,
  fetchSpaceInfo,
  fetchAccessToken,
  regenerateSessionToken,
};
